<template>
  <section class="custom-activity">
    <div class="row">
      <div class="col-md-12 custom-header">
        <div class="input-group custom-title">
          <h4>Weekly Activity</h4>
        </div>
        <week-selector
          v-if="showWeekChooser"
          class="custom-selector"
          :weeks="weeks"
          :week="week"
          @change="weekChanged"
        />
        <div class="custom-minutes" v-if="!showWeekChooser">
          <button
            class="btn btn-link custom-action-button"
            @click="showActiveMinutes"
          >
            Weekly Active Minutes
          </button>
        </div>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col align-self-center">
        <weekly-goals-chart />
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <weekly-activity
          @showSession="showSession"
          @addSession="addSession"
          @removeSessions="removeSessions"
        />
      </div>
    </div>
  </section>
  <session-dialog
    :show="actionSession"
    @close="closeDialogs"
    @showSamples="showSamples"
  />
  <samples-dialog :show="actionSamples" @close="closeSamplesDialog" />
  <minutes-dialog :show="actionMinutes" @close="closeDialogs" />
  <session-add-dialog
    :show="actionSessionAdd"
    @close="closeDialogs"
    @saved="savedSession"
  />
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'
import WeekSelector from '../elements/week-selector'
import WeeklyActivity from './progress/activity-week'
import WeeklyGoalsChart from './progress/activity-week-goal-chart'
import SessionDialog from './sessions/session-dialog'
import SamplesDialog from './sessions/samples-dialog'
import MinutesDialog from './client-minutes-dialog'
import SessionAddDialog from './sessions/session-add-dialog'
export default {
  name: 'client-activity',
  components: {
    WeekSelector,
    WeeklyActivity,
    WeeklyGoalsChart,
    SessionDialog,
    SamplesDialog,
    MinutesDialog,
    SessionAddDialog,
  },
  props: {
    showWeekChooser: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      actionSession: null,
      actionSamples: null,
      actionMinutes: null,
      actionSessionAdd: null,
    }
  },
  mounted() {
    this.weekChanged()
  },
  emits: ['weekChanged', 'changed'],
  computed: {
    ...mapGetters('usercardio', ['member', 'summary']),
    weeks() {
      let _data = []
      if (this.summary) {
        _data = this.summary.weeks
      }
      return _data
    },
    week() {
      let _data = ''
      if (this.summary) {
        _data = this.summary.week.name
      }
      return _data
    },
    date() {
      let _data = ''
      if (this.summary) {
        // TODO: remove subtraction for Production
        _data = moment(this.summary.week.value)
          // .subtract(4, 'years')
          .format('YYYY-MM-DD')
        // _data = moment(this.summary.week.value).format('YYYY-MM-DD')
      }
      return _data
    },
  },
  methods: {
    ...mapActions('usercardio', [
      'getMember',
      'getMemberDailyProgress',
      'getMemberSessionDetail',
      'getMemberProfileHistory',
      'removeMemberSessions',
    ]),
    ...mapActions('global', ['setLoading']),
    closeDialogs() {
      this.actionSession = null
      this.actionSamples = null
      this.actionMinutes = null
      this.actionSessionAdd = null
    },
    closeSamplesDialog() {
      this.actionSamples = null
    },
    editGoals() {},
    async refreshProgress() {
      if (this.member === undefined || this.member === null) {
        await this.getMember({
          id: this.member.id,
          date: this.date,
        })
      }
      await this.getMemberDailyProgress({
        id: this.member.id,
        date: this.date,
      })
    },
    async weekChanged(week) {
      await this.refreshProgress()
      this.$emit('weekChanged', this.date)
    },
    async showSession(row) {
      let data = {
        id: parseInt(row.user_id),
        session: parseInt(row.session_id),
      }
      await this.getMemberSessionDetail(data)
      this.actionSession = row
    },
    addSession() {
      this.actionSessionAdd = true
    },
    async removeSessions(ids) {
      console.log('Session Removal', ids)
      await this.removeMemberSessions({
        userId: this.member.id,
        sessionDate: this.date,
        ids: ids,
      })
      await this.refreshProgress()
      this.$emit('changed')
    },
    async savedSession() {
      await this.refreshProgress()
      this.actionSessionAdd = null
      this.$emit('changed')
    },
    showSamples() {
      this.actionSamples = true
    },
    async showActiveMinutes() {
      this.setLoading(true)
      let data = {
        id: this.member.id,
        date: this.date,
      }
      await this.getMemberProfileHistory(data)
      this.actionMinutes = true
      this.setLoading(false)
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-header {
  position: relative;
}
.custom-title {
  position: absolute;
  left: 0;
  top: 0;
  button {
    top: -10px;
  }
}
.custom-selector {
  width: 265px;
  margin: 0 auto;
}
.custom-activity {
  max-height: 650px;
}
.custom-minutes {
  position: absolute;
  right: 0;
}
.custom-action-button {
  color: #0d6efd;
  font-size: 1.1em;
}
.custom-action-button:focus {
  box-shadow: none !important;
}
</style>
